import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";

const MDSelectInput = ({
  label,
  value,
  onChange,
  options = [],
  error = false,
  helperText = "",
  fullWidth = false,
  sx = {},
  ...otherProps
}) => {
  return (
    <FormControl
      variant="outlined"
      fullWidth={fullWidth}
      error={error}
      sx={{ minWidth: 120, ...sx }}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
        {...otherProps}
        sx={{
          fontFamily: "Inter, sans-serif",
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-input": {
            padding: "16px 14px",
            fontSize: "14px",
          },
          "& .MuiFormHelperText-root": {
            minHeight: "20px",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              fontFamily: "Inter, sans-serif",
              maxWidth: 400,
              whiteSpace: "normal",
              wordWrap: "break-word",
              "& .MuiList-root": {
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                padding: "7px",
              },
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={{
              whiteSpace: "normal",
              lineHeight: 1.4,
              fontFamily: "Inter, sans-serif",
              fontSize: "13px",
              backgroundColor: "#f2f2f2",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default MDSelectInput;
